module.exports = __webpack_public_path__ + "img/br.b84cf701.png";